/**
 * Rutas de la API centralizadas (mismo patrón que wio.front). Cada constante se usa
 * tanto en la llamada axios —resolviendo los `:token` con `generatePath` de
 * react-router-dom— como de prefijo de la `queryKey`/`mutationKey` de React Query.
 */

// wio.suitability.api
export const suitabilityQuestionnaire = '/suitability/questionnaire';
export const suitabilityPreview = '/suitability/preview';
export const clientSuitabilityTests = '/clients/:clientId/suitability/tests';

// wio.api
export const risks = '/risks';
export const client = '/clients/:clientId';
